exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.video_base[data-v-35cb3d78] {\r\n  position: relative;\n}\n.video_base video[data-v-35cb3d78]{\r\n  width: 750px;\r\n  height: 420px;\n}\r\n", ""]);

// exports
